var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummarizeDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66406 21.5254C1.57422 21.5254 0.490234 20.4316 0.490234 18.3223V3.58594C0.490234 1.48633 1.57422 0.382812 3.66406 0.382812H8.12695V7.76562C8.12695 8.98633 8.71289 9.58203 9.93359 9.58203H17.2383V18.3223C17.2383 20.4219 16.1543 21.5254 14.0645 21.5254H3.66406ZM10.1094 8.15625C9.73828 8.15625 9.54297 7.9707 9.54297 7.59961V0.480469C9.99219 0.539062 10.4316 0.871094 10.9102 1.35938L16.252 6.7793C16.75 7.29688 17.0723 7.7168 17.1309 8.15625H10.1094Z",
    fill: "#D0D0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarizeDocument);
export default __webpack_public_path__ + "static/media/summarize_document.6dc3353b7bf3b897aaad610cae41c75d.svg";
export { ForwardRef as ReactComponent };